const CONTAINER_SELECTOR = '.b-gallery';
const IMAGE_SELECTOR = '.b-collection_image_item a.image';

// magnific собирает картинки по delegate в момент клика, поэтому загруженные позже не требуют переинициализации
$(document).on('turbolinks:load', () => {
  const $galleries = $(CONTAINER_SELECTOR);
  if (!$galleries.length) { return; }

  $galleries.magnificPopup({
    delegate: IMAGE_SELECTOR,
    type: 'image',
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1],
      tCounter: '<span class="mfp-counter">%curr% из %total%</span>'
    }
  });
});
